module.exports = __webpack_public_path__ + "media/images/icon_save-4cc1f70651c6cfaba3c9195bd0311455.png";